import APIClient from "../../../common/APIClient";
import {
  toggleShowAlert,
  displayError,
  SUCCESS_ALERT,
  setIsSaving,
  MAX_ITEMS_IN_PAGE,
} from "../commonActions";
import { fetchProjectTasks } from "./projectTasksActions";
import { fetchProjectMembers } from "./projectMembersActions";
import {
  fetchPlatforms,
  fetchPlatformBands,
  SET_PROJECT_PLATFORMS,
} from "../platforms/platformActions";
import { setNumAttachments } from "./projectAttachments";
import {
  fetchProjectScope,
  fetchProjectCostings,
  combineTaskDistributionAndBands,
  fetchChildrenScopes,
  saveProjectCosting,
} from "../projects/projectCostingActions";
import { fetchTimeEntriesPerProject } from "../timesheet/timesheetActions";
import { formatDate } from "../../../common/Utilities";
import qs from "qs";
import { Cache } from "aws-amplify";
import moment from "moment";

export const PENDING = "Pending Approval";
export const APPROVED = "Approved";
export const REJECTED = "Rejected";

export const CREATE_PROJECT = "CREATE_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";

const PROJECT_SET_FIELD_VALUE = "PROJECT_SET_FIELD_VALUE";
const RESET_PROJECT = "RESET_PROJECT";
const FETCH_TOTAL_HOURS_PER_PROJECT = "FETCH_TOTAL_HOURS_PER_PROJECT";
const FETCH_TOTAL_COST_PER_PROJECT = "FETCH_TOTAL_COST_PER_PROJECT";
const FETCH_PROJECTS = "FETCH_PROJECTS";
const FETCH_PROJECTS_BY_ROLE = "FETCH_PROJECTS_BY_ROLE";
const SET_IS_MODIFYING_COST = "SET_IS_MODIFYING_COST";
const RESET_PLATFORM_BANDS = "RESET_PLATFORM_BANDS";
const CLEAR_PROJECTS = "CLEAR_PROJECTS";
const FETCH_PROJECT_HOURS_PER_WEEK = "FETCH_PROJECT_HOURS_PER_WEEK";
const RESET_TOTAL_PROJECT_HOURS = "RESET_TOTAL_PROJECT_HOURS";
const RESET_PROJECT_HOURS_WEEK = "RESET_PROJECT_HOURS_WEEK";
const SET_PROJECT_FILTER = "SET_PROJECT_FILTER";
const RESET_PROJECT_FILTER = "RESET_PROJECT_FILTER";
const SET_PROJECT_SIEVE = "SET_PROJECT_SIEVE";
const FETCH_CHILDREN_PROJECTS = "FETCH_CHILDREN_PROJECTS";
const RESET_ALL_PROJECT_SCOPING = "RESET_ALL_PROJECT_SCOPING";
const FETCH_CLIENT_PROJECTS = "FETCH_CLIENT_PROJECTS";

export const SET_APPROVERS = "SET_APPROVERS";
export const SET_PROJECTS_PAGINATION = "SET_PROJECTS_PAGINATION";
export const RESET_PROJECTS_PAGINATION = "RESET_PROJECTS_PAGINATION";
export const SET_PROJECT = "SET_PROJECT";
export const GENERAL_ADMIN = "GENERAL_ADMIN";

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const upsertProject = (
  action,
  successCallback = null,
  createProjectCost = false,
  toReset = true,
  forApproval = false
) => {
  return (dispatch, getState) => {
    const project = getState().projects.project;
    let approvers = getState().projects.approvers;

    if (approvers.length) {
      approvers = approvers.map((approver, index) => {
        index += 1;
        let approverId = "";
        if (typeof approver.id !== "undefined") {
          approverId = approver.id;
        } else {
          approverId = approver.approver_id;
        }

        return {
          approver_id: approverId,
          sequence: index,
          status: PENDING,
        };
      });
    }

    if (action === "UPDATE_PROJECT") {
      if (typeof project.project_manager === "object") {
        if (project.project_manager) {
          Object.assign(project, {
            project_manager: project.project_manager.id,
          });
        }
      }

      if (typeof project.project_sponsor === "object") {
        if (project.project_sponsor) {
          Object.assign(project, {
            project_sponsor: project.project_sponsor.id,
          });
        }
      }
    }

    let projectId = 0;

    if (project.project_id) {
      projectId = project.project_id;
    }

    Object.assign(project, { project_id: projectId });

    /*
    * FOR ATLAS ONLY
    * SET STATUS TO APPROVED
    * 
    */
    // if (forApproval) {
      Object.assign(project, { approvers });
      Object.assign(project, { status: PENDING });
    // }

    //if start date is undefined, it is automatically set as current date from the from
    if (typeof project.start_date === "undefined") {
      Object.assign(project, { start_date: new Date() });
    } else {
      Object.assign(project, { start_date: new Date(project.start_date) });
    }
    //if end date is undefined, it is automatically set as current date from the from
    if (typeof project.end_date === "undefined") {
      project.end_date = new Date();
    } else {
      project.end_date = new Date(project.end_date);
    }

    //format date before sending to endpoint
    Object.assign(project, {
      start_date: formatDate(project.start_date),
      end_date: formatDate(project.end_date),
      created_by: Cache.getItem("userId"),
    });

    dispatch(setIsSaving(true));

    if (action === "CREATE_PROJECT") {
      //let's update budgeted hours from costing budgeted hours
      project.budgeted_hours = project.costing_budgeted_hours;
    }

    //let's make sure that department_id is an integer and not an object
    if (project.department_id) {
      const department = project.department_id;
      if (
        typeof department === "object" &&
        typeof department.id !== "undefined"
      ) {
        project.department_id = department.id;
      }
    } else {
      project.department_id = 0;
    }

    client()
      .post("projects/upsert", project)
      .then((json) => {
        const result = json.data;
        if (result) {
          let projectId = "";

          if (action === CREATE_PROJECT) {
            projectId = result.data;
          } else {
            const projectData = result.data;
            projectId = projectData.id;
          }
          //Check if platform has been changed
          if (action === "UPDATE_PROJECT") {
            let projPlatforms = getState().projects.project.project_platform;
            let selectedPlatforms = getState().projects.project.platform;

            let platformToDelete = [];

            projPlatforms.length &&
              projPlatforms.forEach((projPlatform, index) => {
                if (!selectedPlatforms.includes(projPlatform.id)) {
                  platformToDelete.push(projPlatform.id);
                }
              });

            platformToDelete.length &&
              platformToDelete.forEach((platform) => {
                client()
                  .get("/project-scoping/delete", {
                    params: {
                      platform_id: platform,
                      project_id: project.id,
                    },
                  })
                  .catch((error) => {
                    dispatch(displayError(error));
                  });

                client()
                  .get("/project-costing/delete", {
                    params: {
                      platform_id: platform,
                      project_id: project.id,
                    },
                  })
                  .catch((error) => {
                    dispatch(displayError(error));
                  });
              });
          }

          //if true, create project cost after creating project
          if (createProjectCost) {
            dispatch(saveProjectCosting(projectId, false));
          }

          if (typeof project.team_members !== "undefined") {
            //save team members
            const teamMembers = {
              project_id: projectId,
              user_ids: project.team_members,
            };

            client()
              .post("/team-members/create", teamMembers)
              .then((json) => {
                const result = json.data;
                if (result) {
                  dispatch(successCreateProject(toReset, action));
                }
              })
              .catch((error) => {
                dispatch(displayError(error));
              });
          } else {
            dispatch(successCreateProject(toReset, action));
          }

          successCallback();
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const successCreateProject = (toReset = true, action) => {
  return (dispatch) => {

    let message = '';

    if(action === "CREATE_PROJECT"){
      message = "Project successfully created.";
    }else if(action === "UPDATE_PROJECT"){
      message = "Project successfully updated.";
    }

    if (toReset) {
      dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
      dispatch({ type: RESET_PROJECT });
    }
    dispatch(setIsSaving(false));
  };
};

export const fetchProjects = (filters = null, successCallback = null) => {
  return (dispatch, getState) => {
    const params = {};


    if (filters && Object.keys(filters).length) {
      Object.assign(params, { filters });
    }

    client()
      .get("projects/list", {
        params,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;

        if (result) {
          let projects = result.data;
          if (projects.length === 0) {
            projects = null;
          } else {
            let numItems = projects.length;

            let min = getState().projects.min;
            let max =
              numItems < MAX_ITEMS_IN_PAGE ? numItems : getState().projects.max;

            const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);

            dispatch({
              type: SET_PROJECTS_PAGINATION,
              numItems,
              min,
              max,
              totalPages,
            });
          }

          dispatch({ type: FETCH_PROJECTS, projects });
          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getProject = (
  project_id,
  notInProjMemberPage = false,
  forApproval = false
) => {
  return (dispatch, getState) => {
    const project = getState().projects.project;

    if (Object.keys(project).length === 0) {
      client()
        .get("projects/get", {
          params: {
            project_id,
          },
        })
        .then((json) => {
          const result = json.data;
          if (result) {
            let project = result.data;
            let arrPlatformIds = [];
            if (project) {
              if (project.project_platform.length) {
                project.project_platform.forEach((platform) => {
                  arrPlatformIds.push(platform.id);
                });

                Object.assign(project, { platform: arrPlatformIds });
              }
              let numAttachments = 1;
              if (project.project_attachments.length) {
                numAttachments = project.project_attachments.length;
              }
              Object.assign(project, { numAttachments });

              dispatch({ type: SET_PROJECT, project });

              if (!forApproval) {
                dispatch(fetchProjectTasks());
                dispatch(fetchProjectMembers(project.id, notInProjMemberPage));
                dispatch(
                  fetchProjectScope({ project_id: project.id }, arrPlatformIds)
                );
                dispatch(fetchProjectCostings({ project_id: project.id }));

                if (typeof project.project_attachments !== "undefined") {
                  let numAttachments = project.project_attachments.length;

                  if (!numAttachments) {
                    numAttachments = 1;
                  }
                  dispatch(setNumAttachments(numAttachments));
                }

                if (project.project_platform.length) {
                  dispatch(fetchPlatforms({ id: arrPlatformIds }, true));

                  dispatch(
                    fetchPlatformBands(
                      {
                        platform_id: arrPlatformIds,
                        fully_loaded: project.fully_loaded,
                        year: project.costing_year,
                      },
                      true
                    )
                  );
                } else {
                  dispatch({
                    type: SET_PROJECT_PLATFORMS,
                    projPlatforms: null,
                  });
                }

                let approvers = project.project_approvers;
                dispatch({ type: SET_APPROVERS, approvers });

                setTimeout(() => {
                  arrPlatformIds.length &&
                    arrPlatformIds.forEach((platformId) => {
                      dispatch(combineTaskDistributionAndBands(platformId));
                    });
                }, 4000);
              }
            }
          }
        })
        .catch((error) => {
          dispatch(displayError(error));
        });
    }
  };
};

export const resetProject = () => {
  return (dispatch) => {
    dispatch({ type: RESET_PROJECT });
  };
};

export const clearProjects = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_PROJECTS });
  };
};

export const deleteProject = (id) => {
  return (dispatch) => {
    client()
      .get("projects/delete", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "Project has been successfully deleted."
            )
          );
          dispatch(fetchProjects());
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const trashProject = (id) => {
  return (dispatch) => {
    client()
      .get("projects/trash", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "Project has been successfully deleted."
            )
          );
          dispatch(fetchProjects());
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const fetchTotalProjectHours = (projectId, errorCallback = {}) => {
  return (dispatch, getState) => {
    const project = getState().projects.project;
    if (Object.keys(project).length === 0) {
      return client()
        .get("time-entries/total-hours-per-project", {
          params: {
            project_id: projectId,
          },
        })
        .then((json) => {
          const result = json.data;
          if (result) {
            let totalProjectHours = result.data;
            if (totalProjectHours) {
              dispatch({
                type: FETCH_TOTAL_HOURS_PER_PROJECT,
                projectId,
                totalProjectHours,
              });
              return totalProjectHours;
            }
          }
        })
        .catch((error) => {
          dispatch(displayError(error));
        });
    }
  };
};

export const fetchTotalProjectCost = (projectId, errorCallback = {}) => {
  return (dispatch, getState) => {
    const project = getState().projects.project;
    if (Object.keys(project).length === 0) {
      return client()
        .get("time-entries/total-cost-per-project", {
          params: {
            project_id: projectId,
          },
        })
        .then((json) => {
          const result = json.data;
          if (result) {
            let totalProjectCost = result.data;
            if (totalProjectCost) {
              dispatch({
                type: FETCH_TOTAL_COST_PER_PROJECT,
                projectId,
                totalProjectCost,
              });
              return totalProjectCost;
            }
          }
        })
        .catch((error) => {
          dispatch(displayError(error));
        });
    }
  };
};

export const resetTotalProjectHours = () => {
  return (dispatch) => {
    dispatch({ type: RESET_TOTAL_PROJECT_HOURS });
  };
};

export const handleFieldChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value;
    if (e) {
      value = {
        [e.target.id]: e.target.value,
      };
    } else {
      value = definedValue;
    }

    dispatch({ type: PROJECT_SET_FIELD_VALUE, value });
  };
};

export const fetchProjectByRole = (filters = {}) => {
  return (dispatch) => {
    const params = {
      user_id: Cache.getItem("userId"),
      role_id: Cache.getItem("roleId"),
    };

    if (filters && Object.keys(filters).length) {
      Object.assign(params, { filters });
    }

    client()
      .get("projects/list-by-role", {
        params,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let projectsByRole = result.data;
          if (projectsByRole.length === 0) {
            projectsByRole = null;
          }
          dispatch({ type: FETCH_PROJECTS_BY_ROLE, projectsByRole });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getProjectsJSON = (params = {}, isAdmin = false) => {
  return (dispatch, getState) => {
    let projects = [];

    if (!isAdmin) {
      let memberProjects = getState().projects.memberProjects || [];

      if (memberProjects.length) {
        projects = memberProjects.map((memberProject) => {
          if (typeof memberProject.project_details !== "undefined") {
            return memberProject.project_details;
          }
          return null;
        });
      }
    } else {
      projects = getState().projects.projects;
    }

    if (
      params.includeGenAdmin &&
      !projects.filter((project) => project.project_id === GENERAL_ADMIN).length
    ) {
      const allProjects = getState().projects.projects;
      const genAdmin = allProjects.filter(
        (project) => project.project_id === GENERAL_ADMIN
      );

      projects = projects.concat(genAdmin);
    }

    if (!params.includeGenAdmin) {
      projects = projects.filter(
        (project) => project.project_id !== GENERAL_ADMIN
      );
    }

    if ("is_disabled" in params) {
      projects = projects.filter(
        (project) => project.is_disabled === params.is_disabled
      );
    }

    return projects && projects.length
      ? projects
          .filter((project) => {
            if (project.project_id === GENERAL_ADMIN) {
              return project;
            }

            if (Object.keys(params).length) {
              if (
                typeof params.sheetStartDate !== "undefined" &&
                typeof params.sheetEndDate !== "undefined"
              ) {
                if (
                  params.sheetStartDate &&
                  params.sheetEndDate &&
                  moment(params.sheetStartDate).isSameOrBefore(
                    moment(project.end_date)
                  ) &&
                  moment(params.sheetEndDate).isSameOrAfter(
                    moment(project.start_date)
                  )
                ) {
                  return project;
                }
              } else {
                return project;
              }
            } else {
              return project;
            }

            return null;
          })
          .map((project, key) => ({
            key: key,
            value: +project.id,
            label: project.project_name,
          }))
      : [];
  };
};

export const setIsModifyingCost = (modifying) => {
  return (dispatch) => {
    dispatch({ type: SET_IS_MODIFYING_COST, modifying });
  };
};

export const resetPlatformBands = () => {
  return (dispatch) => {
    dispatch({ type: RESET_PLATFORM_BANDS });
  };
};

export const fetchTotalProjHoursWeek = (projectId) => {
  return (dispatch) => {
    client()
      .get("time-entries/total-hours-per-project-per-week", {
        params: {
          project_id: projectId,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let projectHoursWeek = result.data;
          if (projectHoursWeek) {
            dispatch({
              type: FETCH_PROJECT_HOURS_PER_WEEK,
              projectId,
              projectHoursWeek,
            });
            return projectHoursWeek;
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const resetProjectHoursWeek = () => {
  return (dispatch) => {
    dispatch({ type: RESET_PROJECT_HOURS_WEEK });
  };
};

export const disableProject = (id) => {
  return (dispatch, getState) => {
    const projectFilter = getState().projects.projectFilter;
    client()
      .get("projects/disable", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "Project has been successfully disabled."
            )
          );
          dispatch(fetchProjects(projectFilter));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const enableProject = (id) => {
  return (dispatch, getState) => {
    const projectFilter = getState().projects.projectFilter;
    client()
      .get("projects/enable", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "Project has been successfully enabled."
            )
          );
          dispatch(fetchProjects(projectFilter));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const setProjectFilter = (projectFilter) => {
  return (dispatch) => {
    dispatch({ type: SET_PROJECT_FILTER, projectFilter });
  };
};

export const resetProjectFilter = () => {
  return (dispatch) => {
    dispatch({ type: RESET_PROJECT_FILTER });
  };
};

export const sieveProject = (projectSieve) => {
  return (dispatch) => {
    dispatch({ type: SET_PROJECT_SIEVE, projectSieve });
  };
};

export const fetchChildrenProjects = (
  projectId,
  startDate = null,
  endDate = null
) => {
  return (dispatch) => {
    dispatch(getProject(projectId));

    client()
      .get("projects/list", {
        params: {
          filters: {
            parent_project: projectId,
          },
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let childrenProjects = result.data;
          //has children projects
          dispatch({ type: FETCH_CHILDREN_PROJECTS, childrenProjects });

          let projectIds = [];

          childrenProjects.length &&
            childrenProjects.forEach((childProject) => {
              projectIds.push(childProject.id);
            });

          projectIds.push(projectId);

          projectIds.forEach((projectId) => {
            dispatch(
              fetchChildrenScopes({ project_id: projectId }, [1, 2, 3, 4])
            );
            dispatch(fetchTimeEntriesPerProject(projectId, startDate, endDate));
          });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const resetAllProjectCosting = () => {
  return (dispatch) => {
    dispatch({ type: RESET_ALL_PROJECT_SCOPING });
  };
};

export const clientProjects = (
  clientId,
  retrieveTimeEntries = false,
  startDate = null,
  endDate = null
) => {
  return (dispatch) => {
    client()
      .get("projects/list", {
        params: {
          filters: {
            client_id: clientId,
            is_disabled: 0,
          },
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;

        let clientProjects = [];

        if (result.data.length) {
          clientProjects = result.data;
        } else {
          clientProjects = null;
        }

        dispatch({ type: FETCH_CLIENT_PROJECTS, clientProjects });

        if (retrieveTimeEntries && clientProjects.length) {
          let projectIds = [];

          clientProjects.forEach((clientProject) => {
            projectIds.push(clientProject.id);
          });

          dispatch(fetchTimeEntriesPerProject(projectIds, startDate, endDate));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const groupClientProjects = (clientProjects) => {
  if (!clientProjects) {
    return null;
  }

  let childrenProjects = [];
  let revisedClientProjects = [];

  clientProjects.length &&
    clientProjects.forEach((clientProject) => {
      //if already included as children project, don't proceed to
      //adding to final array of clients
      if (!childrenProjects.includes(clientProject.id)) {
        let children = [];
        let hasChildren = false;

        clientProjects
          .filter((data) => {
            if (data.parent_project === clientProject.id) {
              return data;
            }
            return false;
          })
          .forEach((childProject) => {
            childrenProjects.push(childProject.id);
            children.push(childProject);
            hasChildren = true;
          });

        if (children.length) {
          revisedClientProjects.push(children.concat(clientProject));
        }

        if (!clientProject.parent_project && !hasChildren) {
          revisedClientProjects.push(clientProject);
        }
      }
    });

  return revisedClientProjects;
};
